<template>
    <product-overview id="HI_overview" title="Group Hospital Indemnity Insurance" :ctaLink="`/${$route.params.id}/hospital-indemnity`">
        <template v-slot:video>
            <hospital-indemnity-video />
        </template>
            <p>Group Hospital Indemnity pays a benefit directly to you, starting at admission, for each day of hospital confinement.</p>
            <template v-slot:key-features>
                <key-feature-bullet>
                    <strong>No deductibles, copays, coinsurance or networks</strong> (see any doctor)
                </key-feature-bullet>
                <key-feature-bullet v-if="product['HIUnderwritingBasis.GMC'] === 'Guaranteed Issue'">
                    <strong>Guaranteed issue</strong> – no medical exams or tests
                </key-feature-bullet>
                <key-feature-bullet>
                    <strong>Portable</strong> – coverage continues if you retire or change jobs, as long as you pay the premiums
                </key-feature-bullet>
            </template>
        </product-overview>
</template>
<script>
import { mapGetters } from 'vuex'
import { HospitalIndemnityVideo } from '@/components/videos'
import KeyFeatureBullet from '@/components/key-feature-bullet'
import ProductOverview from '@/components/product-overviews/product-overview'
export default {
    components: {
        ProductOverview,
        HospitalIndemnityVideo,
        KeyFeatureBullet
    },
    computed: {
        ...mapGetters({
            proposalId: 'getProposalId',
            product: 'getHospitalIndemnity'
        })    
    }
}
</script>
